export default {
	es: {
		enlaces: {
			contacto: "/contacto",
			tutores: "/servicios/tutores",
			titulados: "/servicios/titulados",
			empresas: "/servicios/empresas",
			colaboradores: "/colaboradores",
			ofertas : '/ofertas',
			programas : '/programas',
			faqs: "/faqs",
			cookies: '/politica-de-cookies'
		},
		portalalumno : 'https://portal-leon.dev.doubledot.es/login/antiguos',
		portalalumnoregistro : 'https://portal-leon.dev.doubledot.es/registro',
		portalempresas : 'https://portal-leon.dev.doubledot.es/login/empresas',
		portalempresasregistro : 'https://portal-leon.dev.doubledot.es/solicitar-cuenta',
		portaltutores : 'https://tutor.uvaempleo.com/',
		portalestudianteule : 'https://tutor.uvaempleo.com/'
	},
	en: {
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js